(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-sa-paint-preview-trigger]').forEach((trigger) => {
      if (trigger.dataset.saPaintBound) return;
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      trigger.dataset.saPaintBound = 'true';
      // Avoid the product title's margin reset and ancestor transforms.
      document.body.appendChild(dialog);
      trigger.disabled = false;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        // Keep the HD chart out of initial page requests; load it on first open.
        const image = dialog.querySelector('[data-sa-paint-preview-src]');
        if (image && !image.hasAttribute('src')) {
          const source = image.dataset.saPaintPreviewSrc.trim();
          image.src = source;
          dialog.querySelectorAll('[data-sa-paint-preview-key]').forEach((key) => {
            // Both keys sample the same chart as the enlarged preview.
            key.style.backgroundImage = `url(${JSON.stringify(source)})`;
          });
        }
        dialog.showModal();
        document.documentElement.classList.add('sa-paint-preview-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
      dialog.querySelector('[data-sa-paint-preview-close]').addEventListener('click', () => dialog.close());
      let backdropDown = false;
      dialog.addEventListener('pointerdown', (event) => {
        const rect = dialog.getBoundingClientRect();
        backdropDown = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      });
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
        if (backdropDown && outside) dialog.close();
        backdropDown = false;
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('sa-paint-preview-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(trigger)) return;
        if (dialog.open) dialog.close();
        dialog.remove();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
